import Checkbox from './Checkbox';
import CheckboxGroup from './CheckboxGroup'; // Checkbox.Group = CheckboxGroup;//使用Checkbox.Group代替

Checkbox.Group = CheckboxGroup;
export default Checkbox;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-checkbox/src/index.js